export const SERVICE_GROUP_ENDPOINTS = {
  base: '/service-groups',
  byId: (id: string) => `/service-groups/${id}`,
  entityLinks: (entityId: string) =>
    `/service-groups/links/entity/${entityId}`,
  checkSimilarName: '/service-groups/check-similar-name',
};
